import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { NotificationService } from 'src/app/shared/ui/notifications/notification.service';

@Injectable({
	providedIn: 'root',
})
export class CustomErrorHandler implements ErrorHandler {
	private readonly notification = inject(NotificationService);

	handleError(error: unknown): void {
		// HttpErrorResponse toasts are owned by ErrorInterceptor; the global handler only logs them.
		if (error instanceof HttpErrorResponse) {
			console.error('An HTTP error reached the global handler:', error);
			return;
		}
		console.error('An error occurred:', error);
	}

	handleBackendError(error: HttpErrorResponse): void {
		const problemDetails = toProblemDetails(error);

		// FluentValidation laukų klaidos (400/422 su `errors`) rodomos per formos laukus – vengiam bendro toasto.
		if (problemDetails?.errors && Object.keys(problemDetails.errors).length > 0) {
			this.notification.warning({ message: 'Patikrinkite pažymėtus laukus.' });
			return;
		}

		// Pirmumas: BE atsiųstas `title` / `detail`. Nėra jų – parenkam pranešimą pagal status kodą.
		if (problemDetails?.title || problemDetails?.detail) {
			this.notification.error({ title: problemDetails.title, message: problemDetails.detail });
			return;
		}
		this.notification.error({ message: fallbackMessage(error.status) });
	}
}

function toProblemDetails(error: HttpErrorResponse): ProblemDetails | null {
	const body = error.error;
	// Neapdorota stringo atsako (HTML error page, tinklo klaida) paversti nelaikom ProblemDetails.
	if (!body || typeof body !== 'object') return null;
	return body as ProblemDetails;
}

function fallbackMessage(status: number): string {
	if (status === 0) return 'Nepavyko susisiekti su serveriu.';
	if (status >= 500) return 'Serverio klaida. Bandykite dar kartą vėliau.';
	return 'Įvyko klaida. Bandykite dar kartą.';
}

export interface ProblemDetails {
	type: string;
	title: string;
	detail: string;
	status: HttpStatusCode;
	instance?: string;
	requestId?: string;
	traceId?: string;
	/** FluentValidation field-level errors: path → messages */
	errors?: Record<string, string[]>;
}
